export class RoutePicture {
    get big() {
        return this.picture.url.big;
    }
    get medium() {
        return this.picture.url.medium;
    }
    get small() {
        return this.picture.url.small;
    }
    get meta() {
        return this.picture.meta;
    }
    constructor(picture) {
        this.picture = picture;
        const [lon, lat] = picture.meta.coords.split(',');
        this.lon = parseFloat(lon);
        this.lat = parseFloat(lat);
        this.createdDate = new Date(picture.createdDate);
    }
}
